import { useContext } from 'react'

import { faComments } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { ScheduleChatRoomsContext } from '../../../Providers/ScheduleChatRooms'
import TooltipIconButton from '../../antd/Buttons/TooltipIconButton'
import { secureCalling } from '../../../utils'

const ScheduleMessagingButton = ({ shift, style, onOpen }) => {
  const { setShift } = useContext(ScheduleChatRoomsContext)

  const t = useSelector(selectTranslate)

  const handleClick = () => {
    secureCalling(onOpen)
    setShift(shift)
  }

  return (
    <TooltipIconButton
      icon={faComments}
      style={style}
      text={t('schedule_messaging_button.text')}
      title={t('schedule_messaging_button.title')}
      onClick={handleClick}
    />
  )
}

export default ScheduleMessagingButton
